import {occmClient} from "utils/clients";
import { getLocalizedValue as t} from "../../../i18n";
import { connectorsettings as i18nNamespace } from "../../../i18n/namespace";

const fetchConfig = () => occmClient.get('/occm/api/occm/config');

export default ({dispatch, getState}) => next => async action => {
    const {type, payload} = action;
    
    if (type === "CONNECTOR-SETTINGS:FETCH-CONFIG") {
        try {
            dispatch({
                type: "CONNECTOR-SETTINGS:FETCH-CONFIG-PENDING"
            });
            const {data: config} = await fetchConfig();
            dispatch({
                type: "CONNECTOR-SETTINGS:FETCH-CONFIG-SUCCESS",
                payload: {
                    config
                }
            });

        } catch (e) {
            dispatch({
                type: 'NOTIFICATIONS:ERROR',
                payload: {
                    message: t("failed_to_get_configuration", i18nNamespace),
                    exception: e,
                    group: 'CONNECTOR-SETTINGS'
                }
            });
        }

    }

    return next(action);
}
